import { MobileNavBar } from "modules/bp-mobile/layout/MobileNavBar";
import { SettingsNavBar } from "modules/layout/SettingsNavBar";
import { Route, Routes } from "react-router-dom";

import { routes } from "../../common/routes/routes";
import { usePermissionsChecker } from "../../core/auth/usePermissionsChecker";
import { LegacyNavBar } from "../../modules/booking/LegacyNavBar";

export const NavBarRouter = () => {
  const hasPermissions = usePermissionsChecker();

  return (
    <Routes>
      <Route path="*" element={<LegacyNavBar />} />
      {hasPermissions(
        routes.settings.basePath.permissions,
        routes.settings.basePath.permissionsOperator,
        routes.settings.basePath.customPermissionsCheck
      ) && (
        <Route
          path={`${routes.settings.basePath.path}/*`}
          element={<SettingsNavBar />}
        />
      )}
      {hasPermissions(routes.bpMobile.permissions) && (
        <Route path="mobile/*" element={<MobileNavBar />} />
      )}
    </Routes>
  );
};
